import { application } from "./application"
import { controllers } from "@joemasilotti/bridge-components"
import RadioPlayerController from "./radio_player_controller"
import StationButtonController from "./station_button_controller"
import ButtonController from "./bridge/button_controller"

application.register("radio-player", RadioPlayerController)
application.register("station-button", StationButtonController)
application.register("button", ButtonController)
application.load(controllers)
console.log("📦 Controllers registered:", application.controllers.map(c => c.identifier))